module.exports = __webpack_public_path__ + "img/6.9-Table-Calculated.4f55d492.png";